export default "__VITE_ASSET__DMWi4tT2__"